module.exports = __webpack_public_path__ + "img/ipars3.4894a687.jpg";